import React from 'react'

export default function NoItemsMessage({ children }) {
  return <div className="pv2 ph3 gray-6">{children}</div>
}
